var HeadlineTemplate = function HeadlineTemplate(uscardimg, ussrcardimg) {
  var html = "<div class=\"headline-overlay\">\n    <div class=\"title\">Soviet / American Headlines</div>\n    <div class=\"cards\">\n      <div class=\"card\">".concat(ussrcardimg, "</div>\n      <div class=\"card\">").concat(uscardimg, "</div>\n    </div>\n    <div class=\"help\">* higher value card triggered first, US breaks ties</div>\n  ");
  return html;
};
module.exports = HeadlineTemplate;